/* @flow */
import { SECTION_AD_BOUNDARY } from './__constants__';

import type {
  SectionAdListCallbacks,
  SectionAdListOptions,
  SectionAdListTuple
} from './__types__';

const shouldSkipSection = (
  adCount: number,
  currentSectionIndex: number,
  { adLimit, numSections, isPaidContent }: SectionAdListOptions
): bool => (
  adCount >= adLimit
  ||
  (currentSectionIndex >= numSections - SECTION_AD_BOUNDARY && !isPaidContent)
);

export default (options: SectionAdListOptions, {
  canDisplayAd,
  didDisplayAd,
  didNotDisplayAd,
  didIncrementSection
}: SectionAdListCallbacks): SectionAdListTuple => {
  let { adCount = 0, sectionCount = 1 } = options;
  const { sections, bottomSection, isPaidContent } = options;
  const sectionAdList = new Array(sections.length).fill(false);

  for (let i = 0; i < sections.length; i++) {
    const section = sections[i];
    const shouldSkip = shouldSkipSection(adCount, sectionCount, options);
    const shouldDisplayAd = (
     (canDisplayAd(adCount, section) && !shouldSkip)
     ||
     (section === bottomSection && !isPaidContent)
    );

    if (!shouldSkip) {
      didIncrementSection && didIncrementSection();
    }

    if (shouldDisplayAd) {
      adCount++;
      sectionAdList[i] = true;
      didDisplayAd && didDisplayAd();
    } else {
      didNotDisplayAd && didNotDisplayAd(section);
    }

    sectionCount++;
  }

  return [
    sectionAdList,
    adCount
  ];
};
